import clsx from 'clsx'
import { useUiFromSpecContext } from '../EditorContextProvider'
import { EditElement } from './EditInput/EditInput'
import LeftPanel from './LeftPanel'
import { UseFormReturn } from 'react-hook-form'

export const RenderUiEditor = (props: {
  form: UseFormReturn<any>
  leftPanelClassname?: string
  outerLeftPanelClassname?: string
  componentPanelClassname?: string
  innerLeftPanelClassname?: string
}) => {
  const { show } = useUiFromSpecContext()

  return (
    <div className={clsx(props.outerLeftPanelClassname ? props.outerLeftPanelClassname : 'sticky top-2')}>
      {show && <EditElement form={props.form} />}

      <div className="flex flex-col gap-2 ">
        <div className={clsx('py-3 px-2 border bg-white rounded-lg', props.innerLeftPanelClassname)}>
          <LeftPanel
            leftPanelClassname={props.leftPanelClassname}
            componentPanelClassname={props.componentPanelClassname}
          />
        </div>
      </div>
    </div>
  )
}
